import { Controller } from "@hotwired/stimulus"

// The countdown for an over-limit account's free P&L preview. When it reaches zero the page
// goes to the limit page, which is where the server will send the next request anyway. One
// second of slack is added so the server has always seen the window end by the time we ask.
export default class extends Controller {
  static targets = ["remaining"]
  static values = { seconds: Number, redirect: String }

  connect() {
    this.endsAt = Date.now() + (this.secondsValue + 1) * 1000
    this.tick()
    this.timer = setInterval(() => this.tick(), 250)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const left = Math.max(Math.ceil((this.endsAt - Date.now()) / 1000) - 1, 0)
    this.remainingTarget.textContent = left
    this.element.classList.toggle("is-ending", left <= 10)
    if (left <= 0) {
      clearInterval(this.timer)
      window.location.assign(this.redirectValue)
    }
  }
}
